module.exports = __webpack_public_path__ + "img/image-04.9087c631.webp";